import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { withRouter, Link } from "react-router-dom";
import Images from "../../assets/images/imageData";
import localization from "assets/localization/localization";
const Layout = ({
  children,
  title=null,
  subtitle=null,
  isGoback,
  history,
  className="",
  Buttons = null,
  isLoading = false,
  status,
  linkFlag = false,
  linkUrl = "#",
  pagination = true,
  addNewUser,
  SubmitButtons=null,
  saveChanges=null,
  showPassword=false,
  offerDetails=false,
  checkboxLabel = null,
  gobackFun=null,
}) => {
  return (
    <Fragment>
      <div className={`content-wrapper ${className}`}>
        <div className="layout-header">
          <div className="width">
            {isGoback ? (
              <h4><Link to={linkUrl} onClick={() =>gobackFun?history.push("/applications"): !linkFlag && history.goBack()}>
                <img src={Images?.backArrowNew} alt="" />
                {title}
              </Link>
              </h4>
            ) : (
              <h4><span>{title}</span></h4>
            )}
             <h4><span className="floatRightMr">{subtitle}</span></h4>
          </div>
          <div className="btn-group">
            <div className="d-none d-md-inline-block">
              {status && (
                <span
                  className={`status-td ${
                    status === "In Progress"
                      ? `warm`
                      : status === "Not Started"
                      ? "cold"
                      : status === "Completed"
                      ? "completed"
                      : ""
                  }`}
                >
                  {status}
                </span>
              )}

              {Buttons && Buttons()}
            </div>
          </div>
        </div>
        <div className={pagination ? "panel scrollbar-styling pagination" : "panel scrollbar-styling" }>
          {children}
        </div>
        <div className="btn-group">
          <div className="d-md-none d-block xs-fullwidth">
            {Buttons && Buttons()}
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <div>
            {checkboxLabel && checkboxLabel()}
          </div>
          <div>
            <br></br>
          {SubmitButtons && SubmitButtons()}
          {showPassword&&saveChanges && saveChanges()}
          </div>
        </div>
        {offerDetails&&
      <div style={{marginTop:"100px",textAlign:"center"}}>
        <p className="opacity-50 text-center">
          {localization.offerDetails.infoWarn}
        </p>
        <div className="bottom-text">
            <p>
            <img src={Images.safe} alt="image" className="mr-1" />
            {localization.offerDetails.safeSecure}
            <img src={Images.padlock} className="mr-1 ml-3" alt="image" />
            {localization.offerDetails.privacy}
            </p>
            <p>
            <img src={Images.faq} alt="image" className="mr-1" />
            {localization.offerDetails.haveQue}
            <span className="el-primary-color">
                {localization.offerDetails.faq}
            </span>
            <img
                src={Images.information}
                className="mr-1 ml-3"
                alt="image"
            />
            {localization.needHelp}
            </p>
        </div>
      </div>}
      </div>
    </Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.any,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  isGoback: PropTypes.bool,
  history: PropTypes.object,
  className: PropTypes.string,
  Buttons: PropTypes.func,
};

export default withRouter(Layout);
